import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import 'datatables.net-fixedcolumns';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import CrispBankFilter from '../../filters/CrispBankFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('30', '0', '2020-02-01','0');
var ICICIDumpTable='';

class ICICIR1FileReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            ciutidIds: '',
            loading:false,
            isChange: false,
            object_code:[],
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            bank_names:"",
            download_limit:31
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        isReportAccess(AllAccessPermissions, "icici_full_transaction_report");
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");



        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        //this.get_download_limit();
        this.get_filtered_link_ICICI_r1_report('');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_transaction_dump_report','sparcs')

    }
    get_download_limit(){
        axios.get(config.get('API_URL')+'/filters/get-grd-download-limit/',
       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {

            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                download_limit:response.data
            })


        }).catch(error => {
          console.log(error);
        });
    }


    downLoadRefundReport (e){
        let filters = {
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            report_code:'icici_full_transaction_report',
            user_id: this.state.user_id,
            bank: this.state.bank_names,
            download: 1,
        }
        this.setState({
            filters:filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, '/crisp_reports/icici_full_transaction_report','ICICI_r1_file_dump_report','30');
    }

    get_filtered_link_ICICI_r1_report() {
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var postData = {
            bank: this.state.bank_names,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:'icici_full_transaction_report',
            user_id: this.state.user_id,
        };
        if ($.fn.DataTable.isDataTable('#ICICIDumpTable')) {
            $('#ICICIDumpTable').DataTable().clear().destroy();
        }

        ICICIDumpTable = $('#ICICIDumpTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": true,
                "responsive": false,
                "scrollX": true,
                "searching": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
//                 fixedColumns:   {
//                                 leftColumns: 0,
//                                 rightColumns: 1
//                             },
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/icici_full_transaction_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },

                columns:[
                    { "data": "Payment Intent ID" },
                    { "data": "Payment ID" },
                    { "data": "User ID" },
                    { "data": "Invoice ID" },
                    { "data": "Payment Link ID" },
                    { "data": "Link ID" },
                    { "data": "Link Type" },
                    { "data": "Refund ID" },
                    { "data": "Chargeback ID" },
                    { "data": "Chargeback Ticket Number" },
                    { "data": "Recon Tag" },
                    { "data": "Transaction Type" },
                    { "data": "Transaction Status" },
                    { "data": "Sale Transaction Date" },
                    { "data": "Transaction Date" },
                    { "data": "Captured Amount" },
                    { "data": "Invoice Amount" },
                    { "data": "Recon Txn Flag" },
                    { "data": "Chargeback Flag" },
                    { "data": "Refund Flag" },
                    { "data": "Refund Reason" },
                    { "data": "Settlement Status" },
                    { "data": "Merchant ID" },
                    { "data": "Terminal ID" },
                    { "data": "Acquirer ID" },
                    { "data": "Acquirer RRN" },
                    { "data": "Acquirer Refund RRN" },
                    { "data": "MPR Acquirer RRN" },
                    { "data": "MPR Merchant Name" },
                    { "data": "MPR Invoice ID" },
                    { "data": "MPR Date" },
                    { "data": "MPR Amount" },
                    { "data": "MPR Payer VA" },
                    { "data": "Payout Date" },
                    { "data": "Payout RRN" },
                    { "data": "Payout Amount" },
                    { "data": "Payin RRN" },
                    { "data": "Payout Bank" },
                    { "data": "Payout Method" },
                    { "data": "Payout Status" },
                    { "data": "Payout From" },
                    { "data": "Statement Bank" },
                    { "data": "Stmt Sale Txn Date" },
                    { "data": "Stmt Sale Txn Details" },
                    { "data": "Stmt Withdrawal Amount" }
                ],
                "columnDefs": [
//                    {  render: function (data) {
//                             if(data===null || data===''|| data ==='null'){
//                                 return "<div class='text-wrap width-80'></div>";
//                             }
//                         else{
//                             return "<div class='text-wrap width-80'>" +moment(data).format('D MMM YYYY HH:mm:ss')+ "</div>";
//                             }
//                         },
//                         "width": "80px",
//                         "targets": [3,7]
//                     }
               ],
            });


    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);

        //this.refs.crispBankFilter.resetCrispBankFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            bank_names:'',
            ciutidIds: '',
            isChange: false

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleBank = (optionSelected, bank_names) =>
    {
        this.setState({
            bank_names:bank_names,
            isChange: true
        });
    }

    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">ICICI R1 File Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label>Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
{/*                                             <div className="col-md-3 filter-bottom5 padd-5"> */}
{/*                                                 <label> Bank Name </label> */}
{/*                                                 <CrispBankFilter ref="crispBankFilter" onSelectCrispBank = {this.handleBank} /> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> */}

                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_link_ICICI_r1_report.bind(this)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadRefundReport.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="ICICIDumpTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Payment Intent ID</th>
                                            <th>Payment ID</th>
                                            <th>User ID</th>
                                            <th>Invoice ID</th>
                                            <th>Payment Link ID</th>
                                            <th>Link ID</th>
                                            <th>Link Type</th>
                                            <th>Refund ID</th>
                                            <th>Chargeback ID</th>
                                            <th>Chargeback Ticket Number</th>
                                            <th>Recon Tag</th>
                                            <th>Transaction Type</th>
                                            <th>Transaction Status</th>
                                            <th>Sale Transaction Date</th>
                                            <th>Transaction Date</th>
                                            <th>Captured Amount</th>
                                            <th>Invoice Amount</th>
                                            <th>Recon Txn Flag</th>
                                            <th>Chargeback Flag</th>
                                            <th>Refund Flag</th>
                                            <th>Refund Reason</th>
                                            <th>Settlement Status</th>
                                            <th>Merchant ID</th>
                                            <th>Terminal ID</th>
                                            <th>Acquirer ID</th>
                                            <th>Acquirer RRN</th>
                                            <th>Acquirer Refund RRN</th>
                                            <th>MPR Acquirer RRN</th>
                                            <th>MPR Merchant Name</th>
                                            <th>MPR Invoice ID</th>
                                            <th>MPR Date</th>
                                            <th>MPR Amount</th>
                                            <th>MPR Payer VA</th>
                                            <th>Payout Date</th>
                                            <th>Payout RRN</th>
                                            <th>Payout Amount</th>
                                            <th>Payin RRN</th>
                                            <th>Payout Bank</th>
                                            <th>Payout Method</th>
                                            <th>Payout Status</th>
                                            <th>Payout From</th>
                                            <th>Statement Bank</th>
                                            <th>Stmt Sale Txn Date</th>
                                            <th>Stmt Sale Txn Details</th>
                                            <th>Stmt Withdrawal Amount</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(ICICIR1FileReport)